import { IListEntity } from "@/v1/types/global";

import { IMember } from "../types/TeamMembers/Member.interface";
import { apiClient } from "../utils/apiClient";

export const getTeamMembers = (query?: string) => {
  return apiClient.get<IListEntity<IMember>>(`/api/v1/members?${query}`);
};

export const getMemberApiKey = (id: string, expiration: number) => {
  return apiClient.post<{ jwt: string }>(`/api/v1/members/${id}/credentials`, {
    expiration,
  });
};

export const impersonateUser = (memberId: string) => {
  return apiClient.post<{ jwt: string }>("/api/v1/impersonate", { memberId });
};

export const setTeamMemberRoles = async (memberId: string, roles: number[]) => {
  return apiClient.post(`/api/v1/members/${memberId}/roles`, { roles });
};
